import { getCurrentScope, getScopeOwner, SignalScope } from './contexts.js';
import { createReactiveDefinition, createReactiveSignal, } from './reactive.js';
import { createRelay, createTask } from './async.js';
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const DERIVED_DEFINITION_MAP = new WeakMap();
export function getReactiveFnAndDefinition(fn, opts) {
    let fnAndDef = DERIVED_DEFINITION_MAP.get(fn);
    if (!fnAndDef) {
        const def = createReactiveDefinition(opts?.id, opts?.desc, fn, opts?.equals, false, opts?.paramKey, undefined);
        const defScope = getCurrentScope();
        const reactiveFn = (...args) => {
            const scope = getCurrentScope(defScope);
            const signal = scope.get(def, args);
            return signal.value;
        };
        fnAndDef = [reactiveFn, def];
        DERIVED_DEFINITION_MAP.set(fn, fnAndDef);
    }
    return fnAndDef;
}
export function reactive(fn, opts) {
    return getReactiveFnAndDefinition(fn, opts)[0];
}
export const reactiveMethod = (owner, fn, opts) => {
    const def = createReactiveDefinition(opts?.id, opts?.desc, fn, opts?.equals, false, opts?.paramKey, undefined);
    const reactiveFn = (...args) => {
        return getScopeOwner(owner).get(def, args).value;
    };
    DERIVED_DEFINITION_MAP.set(reactiveFn, [reactiveFn, def]);
    return reactiveFn;
};
export function relay(activate, opts) {
    const scope = getCurrentScope();
    return createRelay(activate, scope, opts);
}
export const task = (fn, opts) => {
    const scope = getCurrentScope();
    return createTask(fn, scope, opts);
};
export function watcher(fn, opts) {
    const def = createReactiveDefinition(opts?.id, opts?.desc, fn, opts?.equals, false, undefined, opts?.tracer);
    const scope = opts?.isolate ? new SignalScope([]) : getCurrentScope();
    return createReactiveSignal(def, undefined, undefined, scope);
}
/**
 * Creates a reactive signal from a compute function. This is useful for when you
 * want to create a signal that does not receive parameters, but is still reactive.
 *
 * @param compute
 * @param opts
 * @returns
 */
export const reactiveSignal = (compute, opts) => {
    const def = createReactiveDefinition(opts?.id, opts?.desc, compute, opts?.equals, false, undefined, undefined);
    const scope = opts?.isolate ? new SignalScope([]) : getCurrentScope();
    return createReactiveSignal(def, undefined, undefined, scope);
};
